/**
 * @Description:
 * @author WZP
 * @date 2021/8/25
 */

import classNames from 'classnames/bind';
import React from 'react';
import styles from './styles.scss';


const cx = classNames.bind(styles);

function PageContainer(props: Record<string, any>) {
	const { children, className } = props;
	return (
		<div className={cx('page-container', { [className]: !!className })}>
			{/* <Header /> */}
			<div className={cx('page-content')}>
				{children}
				{/* <Footer /> */}
			</div>
		</div>
	);
}

export default PageContainer;
